export function updateAnalyticsPage(query:string, pageTitle:string):void {
	try {
		// if (window["sendPagePath"]){
		// 	window["sendPagePath"](`/RecorderAce/${page}`);
		// }
		if (window["gtag"]){
			window["gtag"]('event', 'page_view', {
				page_title: pageTitle,
				page_location: `/RecorderAce/${query}`
			});
		}
	}
	catch(e){

	}
}